<template>
  <div>
    <div class="tab">
      <div class="wrapper tw-p-0">
        <span class="font-size-24 tw-font-balto tw-font-medium tw-text-title-2">Mais</span>
        <div class="list tw-mt-2">
          <button v-for="item in items" :key="item.name" class="item" @click="$emit('selected', item)">
            <div>
              <AppIcon class="tw-fill-gray-600" :icon="item.icon" />
              <span class="font-size-14 tw-tracking-[.1px] tw-text-body-1">{{ item.title }}</span>
            </div>
            <AppIcon class="tw-fill-gray-600" icon="chevron-right" />
          </button>
          <hr class="tw-bg-blue-100 tw-text-blue-gray-100" v-if="items.length" />
          <button class="item tw-text-gray-600 hover:tw-bg-blue-gray-100" @click="openModal('Ajuda')">
            <div>
              <AppIcon class="tw-fill-gray-600" icon="lifebuoy" />
              <span class="font-size-14 tw-tracking-[.1px] tw-text-body-1">Ajuda</span>
            </div>
            <AppIcon class="tw-fill-gray-600" icon="chevron-right" />
          </button>
        </div>
      </div>
    </div>
    <SidebarModal
      @handle="itemOptionModalIsOpen = false"
      :selected="selectedOption"
      :projects="projects"
      v-if="itemOptionModalIsOpen"
    />
  </div>
</template>
<script>
import AppIcon from '@/v2/components/ui/icon/AppIcon.vue'
import SidebarModal from './SidebarModal.vue'

export default {
  name: 'SidebarTab',
  components: {
    AppIcon,
    SidebarModal,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      itemOptionModalIsOpen: false,
      selectedOption: null,
    }
  },
  methods: {
    openModal(selected) {
      this.itemOptionModalIsOpen = true
      this.selectedOption = selected
    },
  },
}
</script>
<style scoped>
.tab {
  background-color: #fff;
  position: absolute;
  top: 56px;
  z-index: 1;
  width: 100%;
  height: 100%;
  padding: 24px 16px;
}

.wrapper {
  height: calc(100% - 120px);
  overflow-y: auto;
  scrollbar-width: none;
}

.list .item {
  padding: 10px 8px;
  width: 100%;
  height: 44px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.list .item div {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}

hr {
  border: none;
  height: 1px;
  margin: 12px auto;
}
</style>
